/**
 * Reads a dynamic dictionary key without assuming that the key exists.
 * @param record - Dictionary being read.
 * @param key - Requested key.
 * @returns Its value, or undefined when the key is absent.
 */
export const getRecordValue = <T>(
  record: Readonly<Record<string, T>>,
  key: string
): T | undefined => record[key];
